import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { NewNodalOfficerDashboardModel } from "src/app/model/NewNodalOfficerDashboardModel";
import { DashboardService } from "src/app/services/dashboard.service";
import { IgxLegendComponent, IgxCategoryChartComponent } from 'igniteui-angular-charts';
import { ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";





@Component({
  selector: "new-dashboard",
  templateUrl: "./new-dashboard.component.html",
  styleUrls: ["./new-dashboard.component.scss","./external.component.scss"],
})
export class NewDashboardComponent implements OnInit {
  userName: string;
  nodalOfficerDashboardModel: NewNodalOfficerDashboardModel;
  loaded: boolean = false;
  date: Date;
  nocPendingCount:number;
  @ViewChild("legend", { static: true } )
  private legend: IgxLegendComponent
  @ViewChild("chart", { static: true } )
  private chart: IgxCategoryChartComponent
  mumbaiPaid: number ;
  mumbaiWinner: number;
  mumbaiWaitlist: number;
  // konkanPaid: number;
  // konkanWinner: number;
  // konkanWaitlist: number;
  // punePaid: number;
  // puneWinner: number;
  // puneWaitlist: number;
  // aurangabdPaid: number;
  // aurangabadWinner: number;
  // aurangabadWaitlist: number;
  successMessage: string;
  errorMessage: String;
  isSubmitDisabled: boolean = false;
  lotteryKey:number;


  lotetryFilter: FormGroup = new FormGroup({});
  lotteries: {[key: number]: string};
  filterForm: FormGroup = new FormGroup({});
  form: FormGroup = new FormGroup({});
  chartOptions;
  displayedColumns: string[] = [
    "key",
    "lottery",
    "actionTime",
    "status",
  ];

  constructor(private router: Router, private dashboardService: DashboardService, 
    private modalCtrl: ModalController) { }
    
  ngOnInit(): void { 
    
    this.filterForm = new FormGroup({
      lotteryKey: new FormControl("", Validators.required),
      filterText: new FormControl(null, [
        Validators.required,
        Validators.minLength(2),
      ]),
      lotetryFilter: new FormControl()
     
    });
//this.mumbaiPaid=this.nodalOfficerDashboardModel.mumbaiPaid
    this.loadData();
    
  }

  refresh() {
    this.ngOnInit();
  }
  loadData() {
    let roles = localStorage.getItem("roles");
    this.userName = localStorage.getItem("userName");
    this.loaded = false;
    this.date = null;
    
      console.log(roles,"from rolls");
      this.dashboardService.fetchNodalOfficerDashboard(
        this.filterForm.value.lotetryFilter
      ).subscribe(dashboard => {
        this.nodalOfficerDashboardModel = dashboard;
        
        this.date = new Date();
        this.mumbaiPaid=dashboard.mumbaiPaid;
        this.mumbaiWinner=dashboard.mumbaiWinner;
        this.mumbaiWaitlist=dashboard.mumbaiWaitlist;
        // this.konkanPaid=dashboard.konkanPaid;
        // this.konkanWinner=dashboard.konkanWinner;
        // this.konkanWaitlist=dashboard.konkanWaitlist;
        // this.punePaid=dashboard.punePaid;
        // this.puneWinner=dashboard.puneWinner;
        // this.puneWaitlist=dashboard.puneWaitlist;
        // this.aurangabdPaid=dashboard.aurangabdPaid;
        // this.aurangabadWinner=dashboard.aurangabadWinner;
        // this.aurangabadWaitlist=dashboard.aurangabadWaitlist;
        console.log(this.mumbaiPaid,"Paid");
        this.lotteries = dashboard.lotteries;
        console.log(this.lotteries,"lotteries");
        this.loaded = true;

        this.chartOptions = {
    
          animationEnabled: true,
          exportEnabled: true,
          title: {
          text: "Paid Application Vs Winner Vs Waitlist"
          },
          axisX: {
          labelAngle: 180
          },
          axisY: {
          title: "No Of Applications"
          },
          toolTip: {
          shared: true
          },
          legend:{
          cursor:"pointer",
          itemclick: function(e: any){
            if (typeof(e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
            e.dataSeries.visible = false;
            }
            else {
            e.dataSeries.visible = true;
            }
            e.chart.render();
          }
          },
          data: [{
          type: "column",	
          name: "No Of EMD Paid Application",
          legendText: "No of Emd Paid Application",
          showInLegend: true, 
          dataPoints:[
            {label: "CSMC", y: this.mumbaiPaid},
            // {label: "Konkan", y: this.konkanPaid},
            // {label: "Aurangabad", y: this.aurangabdPaid},
            // {label: "Pune", y: this.punePaid}
          ]
          }, {
          type: "column",	
          name: "No Of Winner",
          legendText: "Winner",
          // axisYType: "secondary",
          showInLegend: true,
          dataPoints:[
            {label: "CSMC", y: this.mumbaiWinner},
            // {label: "Konkan", y: this.konkanWinner},
            // {label: "Aurangabad", y: this.aurangabadWinner},
            // {label: "Pune", y: this.puneWinner}
          ]
          },{
            type: "column",	
            name: "No Of Waitlist",
            legendText: "Waitlist",
            // axisYType: "secondary",
            showInLegend: true,
            dataPoints:[
              {label: "CSMC", y: this.mumbaiWaitlist},
              // {label: "Konkan", y: this.konkanWaitlist},
              // {label: "Aurangabad", y: this.aurangabadWaitlist},
              // {label: "Pune", y: this.puneWaitlist}
            ]
            }
        
        ]
        }	
      });

      
  }

   lotteryWiseData() {
    if (this.lotteryKey){
      console.log(this.filterForm.value.lotteryKey,"Data");

    }
    else {
           this.errorMessage;
           this.dashboardService.errorToast("Please select Lottery and push the back button to return to the original page.");
           this.isSubmitDisabled=false;
           this.loaded=true;
         }

   }
 
   
  
  onChangeLotteryFilter(value) {
    console.log(value);
    this.lotteryKey=value.key;
    console.log(this.lotteryKey);
  }

  
  
 

 
}